import React, { FC } from "react";
import ReactDOM from "react-dom";
import styled from "styled-components";
import useContentful from "./hooks/useContentful";
import contentfulComponentLoop from "./lib/contentfulComponentLoop";
import { ModalContextProvider } from "./contexts/ModalContext";
import getContentfulLocale from "./lib/getContentfulLocale";

const Container = styled.div<{ $ghostNavEnabled: boolean }>`
  @media (min-width: 993px) {
    padding-top: ${({ $ghostNavEnabled }) =>
      $ghostNavEnabled ? '0px' : '56px'};
  }

  ${({ $ghostNavEnabled }) => $ghostNavEnabled && `
    margin-top: -72px;
  `}
`;

const renderTarget = 'marketing-page-react-target';

const Index: FC = () => {
  const ghostNavEnabled = document.documentElement.getAttribute('data-ghost-nav-enabled') === 'true';

  const targetEl = document.getElementById(renderTarget);
  const entryId = targetEl?.dataset.entryId;
  if (!entryId) return;

  let localeString = targetEl?.dataset.shopLocale;
  let localeMarket = targetEl?.dataset.shopMarket;
  const locale = getContentfulLocale(localeString, localeMarket);

  const { contentfulData } = useContentful({ include: 10, 'sys.id': entryId, locale });

  if (contentfulData) {
  const pageFields = contentfulData.items[0].fields;

    return (
      <ModalContextProvider>
      <Container $ghostNavEnabled={ghostNavEnabled}>
        {contentfulComponentLoop(pageFields.components, {
          locale,
          ghostNavEnabled
        })}
        </Container>
      </ModalContextProvider>
    );
  }

  return null;
};

ReactDOM.render(<Index />, document.getElementById(renderTarget));